@let paymentSummary = paymentSummaryInput();

<!-- Header -->
<label class="color-gray-100 body-400-short">{{ paymentSummary.client.name }}</label>

<!-- Payables — invoices and prepayments (PP-3636) each surface as their own removable line. -->
@let invoiceCount = paymentSummary.payables.count - paymentSummary.prepayments.count;
@let invoiceTotal = paymentSummary.payables.total - paymentSummary.prepayments.total;

<!-- Invoices (combined payables minus the prepayment subset) -->
<div *ngIf="invoiceCount > 0" class="d-flex align-items-center">
  <aiwyn-icon
    name="x"
    class="cursor-pointer me-2 remove-selected-client-invoices-icon"
    (click)="invoicesRemoved.emit(paymentSummary.client.id)"
  ></aiwyn-icon>

  <p class="flex-grow-1 color-gray-200 body-300">
    {{ invoiceCount }} invoice{{ invoiceCount === 1 ? '' : 's' }} selected
  </p>
  <p class="color-gray-300 body-300">{{ invoiceTotal | currency: currency().code }}</p>
</div>

<!-- Prepayments (PP-3636): failed prepayments combinable with invoices in a single payment. -->
<div *ngIf="paymentSummary.prepayments.count > 0" class="d-flex align-items-center" data-cy="prepayment-summary-line">
  <aiwyn-icon
    name="x"
    class="cursor-pointer me-2 remove-selected-client-invoices-icon"
    (click)="prepaymentsRemoved.emit(paymentSummary.client.id)"
  ></aiwyn-icon>

  <p class="flex-grow-1 color-gray-200 body-300">
    {{ paymentSummary.prepayments.count }} prepayment{{ paymentSummary.prepayments.count === 1 ? '' : 's' }} selected
  </p>
  <p class="color-gray-300 body-300">{{ paymentSummary.prepayments.total | currency: currency().code }}</p>
</div>

<!-- Late fees -->
<div
  *ngIf="paymentSummary.lateFeesTotal > 0"
  class="d-flex align-items-center"
  [ngClass]="{ 'late-fee-hide-checkbox': configService.paymentLateFeeRequired }"
>
  <mat-checkbox
    [checked]="paymentSummary.lateFeesApplied === paymentSummary.lateFeesTotal"
    [indeterminate]="paymentSummary.lateFeesApplied > 0 && paymentSummary.lateFeesApplied < paymentSummary.lateFeesTotal"
    [disabled]="configService.paymentLateFeeRequired"
    class="color-gray-300 flex-grow-1"
    (change)="onPayLateFeeChange($event.checked)"
  >
    <span class="color-gray-300">
      {{ configService.lateFeeDisplayName | titlecase | pluralBasic }}
    </span>

    <p class="small-300 color-gray-200">
      Total unpaid: {{ paymentSummary.lateFeesTotal | extendedCurrency: currency().code }}
    </p>

    <!--<p *ngIf="!paymentSummary.payLateFees" class="w-100 small-300">
      Note that you are still responsible for this {{ configService.lateFeeDisplayName | lowercase }}.
    </p>-->
  </mat-checkbox>

  <p class="body-300 ms-2 text-nowrap color-gray-300">
    {{ paymentSummary.lateFeesApplied ? (paymentSummary.lateFeesApplied | extendedCurrency: currency().code) : '– –' }}
  </p>
</div>

<!-- Credit -->
<div *ngIf="paymentSummary.creditTotal < 0" class="d-flex align-items-center">
  <mat-checkbox
    class="flex-grow-1"
    [ngClass]="'color-' + (paymentSummary.creditApplied < 0 ? 'primary' : 'green') + '-400'"
    [checked]="paymentSummary.creditApplied < 0"
    (change)="onCreditAppliedChange($event.checked)"
  >
    <div class="d-flex align-items-center gap-1 color-gray-300">
      Credits
      <aiwyn-icon
        name="info"
        tooltip="Credits are applied to the account balance and can be used for future payments."
        class="icon-color-gray-700"
      ></aiwyn-icon>
    </div>

    <p class="small-300 color-gray-200">
      Total available: {{ -paymentSummary.creditTotal | extendedCurrency: currency().code }}
    </p>
  </mat-checkbox>

  <p class="body-300 ms-2" [ngClass]="paymentSummary.creditApplied < 0 ? 'text-color-primary-base' : 'color-gray-300'">
    {{ paymentSummary.creditApplied === 0 ? '– –' : (paymentSummary.creditApplied | extendedCurrency: currency().code) }}
  </p>
</div>

<!-- Add-ons -->
<div *ngFor="let addOn of paymentSummary.addOns" class="d-flex align-items-start">
  <aiwyn-icon name="x" class="cursor-pointer me-2" (click)="addOnRemoved.emit(addOn.id)"></aiwyn-icon>

  <div class="flex-grow-1">
    <div class="d-flex align-items-center gap-1">
      <p class="color-gray-200 body-300">{{ addOn.name }}</p>
      <aiwyn-icon name="info" tooltip="Credits cannot be used towards add-ons." class="icon-color-gray-700"></aiwyn-icon>
    </div>

    <div class="markdown color-gray-200 small-300" [innerHTML]="addOn.notes | marked"></div>
  </div>

  <p class="color-gray-300 body-300 ms-2">{{ addOn.paymentAmount | currency: currency().code }}</p>
</div>

<!-- Subtotal -->
<div class="d-flex align-items-center">
  <p class="color-gray-100 body-600 flex-grow-1 client-payment-summary-subtotal">Account Subtotal</p>

  <p class="color-gray-100 body-600 ms-2">{{ paymentSummary.subtotal | currency: currency().code }}</p>
</div>
